/* RESPONSIBLE TEAM: team-knowledge-foundations */
import { helper as buildHelper } from '@ember/component/helper';
import articleTimeAgo from 'embercom/lib/article-time-ago';

export default buildHelper(function (params) {
  let dateString = params[0];
  return articleTimeAgo(dateString);
});
